import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles, Sun } from 'lucide-react';
export function WhatYouGet() {
  return <section id="solucion" className="py-24 px-4 relative overflow-hidden bg-[#2C2541] pt-[0px] pb-[0px]" data-id="element-302">
      <div className="max-w-5xl mx-auto text-center relative z-10 space-y-[10px]" data-id="element-303">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#D9B15F]/10 border border-[#D9B15F]/30 text-[#D9B15F] text-sm font-medium mb-8" data-id="element-304">
          <Sun className="w-4 h-4" data-id="element-305" />
          <span data-id="element-306">Un nuevo comienzo</span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-6xl font-serif font-bold text-[#D9B15F] mb-8 leading-tight" data-id="element-307">
          Existe una manera diferente de empezar a sanar.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="space-y-6 text-xl md:text-2xl text-[#F8F5F2] leading-relaxed max-w-4xl mx-auto" data-id="element-308">
          <p data-id="element-309">
            El{' '}
            <span className="text-[#D9B15F] font-bold" data-id="element-310">
              Kit Emocional: Lo Que No Sueltas
            </span>{' '}
            fue creado para ayudarte a comprender lo que sentís, identificar
            aquello que todavía te pesa y comenzar un proceso de liberación
            emocional desde un lugar de amor propio y conciencia.
          </p>
          <p className="text-[#B99BE8] font-medium" data-id="element-311">
            No necesitás tener experiencia previa ni "hacer todo perfecto".
          </p>
          <p className="text-[#D9B15F] italic" data-id="element-312">
            Solo necesitás regalarte un momento para vos.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-16 flex justify-center" data-id="element-313">
          <div className="p-1 rounded-full bg-gradient-to-r from-violet-500 to-lilac-500" data-id="element-314">
            <div className="bg-[#0f0720] rounded-full p-4" data-id="element-315">
              <Heart className="w-12 h-12 text-violet-400" data-id="element-316" />
            </div>
          </div>
        </motion.div>
      </div>

      {/* Decorative Stars */}
      <div className="stars-container opacity-30" data-id="element-317">
        {[...Array(15)].map((_, i) => <div key={i} className="star" style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${Math.random() * 2}px`,
        height: `${Math.random() * 2}px`,
        '--duration': `${4 + Math.random() * 6}s`
      } as any} data-id="element-318" />)}
      </div>
    </section>;
}